import { render, staticRenderFns } from "./menu-tree.vue?vue&type=template&id=40bd43a5&scoped=true&"
import script from "./menu-tree.vue?vue&type=script&lang=js&"
export * from "./menu-tree.vue?vue&type=script&lang=js&"
import style0 from "./menu-tree.vue?vue&type=style&index=0&id=40bd43a5&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bd43a5",
  null
  
)

export default component.exports